/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import _forEach from "lodash/forEach";
import Typography from "@mui/material/Typography";
import { dayjsToGermanDate } from "@/src/services/formatService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { Box } from "@mui/material";

type AlimonyChildrenProps = {
  formData: AbstractCase | Record<string, any>;
  translate: Function;
};

const AlimonyChildren = ({ formData, translate }: AlimonyChildrenProps) => {
  if (formData.children && formData.children.length === 0) {
    return null;
  }

  const ChildList = () => {
    let resultList: React.ReactNode[] = [];
    _forEach(formData.children, (child, index) => {
      resultList.push(
        <React.Fragment key={index}>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={`children[${index}].name`} sx={summaryStyle.scrollToAnchor} />
            {child.name} - geb: {dayjsToGermanDate(child.birthDate)}
          </Grid>
          <Grid size={12}>
            {translate(`children.childOf.${child.childOf}`, formData)}, Lebt {translate(`children.livesWith.${child.livesWith}`, formData)},
            Kindergeldempfänger: {translate(`children.childAllowanceReceiver.${child.childAllowanceReceiver}`, formData)}
          </Grid>
        </React.Fragment>
      );
    });
    return <>{resultList}</>;
  };
  return (
    <>
      <Grid sx={summaryStyle.subHeadline} size={12}>
        <Typography variant={"h6"}> Angaben zu den Kindern</Typography>
      </Grid>
      <ChildList />
    </>
  );
};

// @ts-ignore
export default AlimonyChildren;
